import { render, staticRenderFns } from "./InvoiceDeliveryLogs.vue?vue&type=template&id=5f6db3a4&scoped=true&"
import script from "./InvoiceDeliveryLogs.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDeliveryLogs.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDeliveryLogs.vue?vue&type=style&index=0&id=5f6db3a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6db3a4",
  null
  
)

export default component.exports